/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useState } from 'react';
import { Checkbox, formatDate, IconSelected } from '@ui/src';
import {
  NotificationItemIssueStatus,
  NotificationItem as NotificationItemProps,
} from '../../hoc/center/types';
import { NotificationTypes } from './types';

import cn from './styles.module.css';

const NotificationItem = ({
  notification,
  selectedNotifications,
  employees,
  selectedNotificationId,
  setSelectedNotification,
  setSelectedNotifications,
}: NotificationTypes) => {
  const [focused, setFocused] = useState(false);

  const categoryTitle = notification?.category
    .split('_')
    .map((item) => `${item.charAt(0)}${item.slice(1).toLowerCase()}`)
    .join(' ')
    ?.replace('Issues', 'Tasks');
  const groupTitle = notification?.group
    .split('_')
    .map((item) => `${item.charAt(0)}${item.slice(1).toLowerCase()}`)
    .join(' ')
    ?.replace('Issues', 'Tasks');
  const actionTitle = notification?.type
    .split('_')
    .map((item) => `${item.charAt(0)}${item.slice(1).toLowerCase()}`)
    .join(' ')
    ?.replace('Issues', 'Tasks');

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      className={`${cn.notificationItem} ${
        selectedNotificationId === notification?.id ? cn.active : ''
      }`}
      onClick={() => {
        if (!focused && selectedNotificationId !== notification?.id) {
          setSelectedNotification(notification as NotificationItemProps);
        }
      }}
    >
      <div
        className={cn.notificationItemLeft}
        onMouseEnter={() => setFocused(true)}
        onMouseLeave={() => setFocused(false)}
      >
        <Checkbox
          name={`selected-${notification?.id}`}
          type="checkbox"
          title=""
          checked={selectedNotifications?.includes(notification?.id as string)}
          onChange={() => {
            let nextSelectedNotifications = ([] as string[]).concat(
              selectedNotifications as string[],
            );

            if (
              nextSelectedNotifications?.find(
                (item) => item === notification?.id,
              )
            ) {
              nextSelectedNotifications = nextSelectedNotifications?.filter(
                (item) => item !== notification?.id,
              );
            } else {
              nextSelectedNotifications.push(notification?.id as string);
            }

            setSelectedNotifications(nextSelectedNotifications);
          }}
        />
      </div>
      <div className={cn.notificationItemRight}>
        <div className={cn.notificationItemRightTop}>
          <div className={cn.notificationBreadcrumbs}>
            {`${categoryTitle?.charAt(0)}${categoryTitle
              ?.slice(1)
              .toLowerCase()} / ${groupTitle}`}
          </div>
          <div className={cn.notificationDate}>
            {formatDate(notification?.createdAt as string, true)}
          </div>
        </div>
        <div className={cn.notificationTitle}>
          {`${categoryTitle?.charAt(0)}${categoryTitle
            ?.slice(1)
            .toLowerCase()} - ${actionTitle?.replace(
            categoryTitle as string,
            '',
          )}`}
        </div>
        {notification?.organization && (
          <div className={cn.notificationOrganization}>
            {`Customer: ${
              notification?.organization?.firstName
                ? `${notification?.organization?.firstName} ${notification?.organization?.lastName}`
                : notification?.organization?.companyName
            }`}
          </div>
        )}
        <div className={cn.notificationStatusWrapper}>
          <div
            className={`${cn.notificationStatus} ${
              notification?.issue?.status === NotificationItemIssueStatus.TODO
                ? cn.todoStatus
                : ''
            } ${
              notification?.issue?.status ===
              NotificationItemIssueStatus.IN_PROGRESS
                ? cn.inprogressStatus
                : ''
            } ${
              notification?.issue?.status === NotificationItemIssueStatus.DONE
                ? cn.doneStatus
                : ''
            } ${
              notification?.issue?.status ===
              NotificationItemIssueStatus.CANCELED
                ? cn.canceledStatus
                : ''
            }`}
          >
            {notification?.issue && notification?.issue?.status
              ? notification?.issue?.status
                  ?.split('_')
                  ?.map(
                    (item) => `${item.charAt(0)}${item.slice(1).toLowerCase()}`,
                  )
                  .join(' ')
              : 'None'}
          </div>
          {notification?.issue?.executorId && (
            <div className={cn.notificationExecutor}>
              <IconSelected />
              {
                employees?.find(
                  (item) => item.value === notification?.issue?.executorId,
                )?.name
              }
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationItem;
